import { FromStore, Project } from '@cartwhl/common/types';

export default function getCharacterDataFromProject(
  project: FromStore<Project> | undefined,
) {
  if (!project) return;
  const objectIds = Object.keys(project.characters ?? {});
  const characterID = project.characters[objectIds[0]].characterID;
  const meshPath = project.characters[objectIds[0]].meshURL;
  const rotationOffsets = project.characters[objectIds[0]].rotationOffsets;

  return { characterID, meshPath, rotationOffsets };
}
